"use strict";

exports.__esModule = true;
exports.TAG_LINE_MAX_LENGTH = exports.COMPANY_NAME_MAX_LENGTH = void 0;
exports.validateCompanyName = validateCompanyName;
exports.validateTagLine = validateTagLine;
var COMPANY_NAME_MAX_LENGTH = 50;
exports.COMPANY_NAME_MAX_LENGTH = COMPANY_NAME_MAX_LENGTH;
var TAG_LINE_MAX_LENGTH = 50;
exports.TAG_LINE_MAX_LENGTH = TAG_LINE_MAX_LENGTH;

function validateCompanyName(companyName, emptyTextError, tooLongTextError) {
  var validationMessageKey = null;
  var isEmpty = !companyName || typeof companyName === 'string' && !companyName.trim();

  if (isEmpty) {
    validationMessageKey = emptyTextError;
  } else if (typeof companyName === 'string' && companyName.length > COMPANY_NAME_MAX_LENGTH) {
    validationMessageKey = tooLongTextError;
  }

  return validationMessageKey;
}

function validateTagLine(tagName, tooLongTextError) {
  var validationMessageKey = null;

  if (typeof tagName === 'string' && tagName.length > TAG_LINE_MAX_LENGTH) {
    validationMessageKey = tooLongTextError;
  }

  return validationMessageKey;
}